import OrdersMobile from './OrdersMobile';

export default OrdersMobile;
